import { render } from "./vendor-invoice.vue?vue&type=template&id=6334ba41&scoped=true"
import script from "./vendor-invoice.vue?vue&type=script&lang=js"
export * from "./vendor-invoice.vue?vue&type=script&lang=js"

import "./vendor-invoice.vue?vue&type=style&index=0&id=6334ba41&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6334ba41"]])

export default __exports__